import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlEndPoints } from '../config/end-points';
import { ReasonMap } from '../models/reasonMap.model';

@Injectable({
  providedIn: 'root',
})
export class ReasonMapDal {
  constructor(private httpClient: HttpClient) {}

  getSuggestedReasonsMaps(
    includeNotSuggested: boolean = false,
    populateRules: boolean = false
  ): Observable<ReasonMap[]> {
    return this.httpClient.get<any>(
      urlEndPoints.reasonsMaps +
        'suggested' +
        (includeNotSuggested ? '/?includeNotSuggested=true' : '/?includeNotSuggested=false') +
        (populateRules ? '&populateRules=true' : '/?populateRules=false')
    );
  }

  getAllReasonsMaps(
    page: number = 1,
    limit: number = 10,
    positions: string[],
    sort?: { field: string; direction: number },
    search?: { [key: string]: string }
  ): Observable<{ [key: string]: any }> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('page', page.toString()).append('limit', limit.toString());
    if (sort && sort.field && sort.direction) {
      httpParams = httpParams.append('sort[field]', sort.field).append('sort[direction]', sort.direction.toString());
    }
    if (search) {
      for (const [key, value] of Object.entries(search)) {
        if ('string' === typeof value && '' !== value.trim()) {
          httpParams = httpParams.append('search[' + key + ']', value);
        }
      }
    }
    httpParams = httpParams.append('timezone', 'UTC');
    httpParams = httpParams.append('positions', positions.join(','));
    return this.httpClient.get<any>(urlEndPoints.reasonsMaps + 'getAllReasonsMaps', { params: httpParams });
  }

  createReasonMap(reasonMap: ReasonMap): Observable<ReasonMap> {
    return this.httpClient.post<ReasonMap>(urlEndPoints.reasonsMaps + 'createReasonMap', reasonMap);
  }

  updateReasonMap(reasonMap: ReasonMap): Observable<ReasonMap> {
    return this.httpClient.put<ReasonMap>(urlEndPoints.reasonsMaps + 'updateReasonMap', reasonMap);
  }

  getTmpReasonMap(profile: string, programs: any[]): Observable<any> {
    return this.httpClient.post<ReasonMap>(urlEndPoints.reasonsMaps + 'getTmp', { profileId: profile, programs });
  }

  getVacations(date: string): Observable<any> {
    return this.httpClient.get<any>(urlEndPoints.reasonsMaps + 'getVacations/' + date);
  }

  getNightReasonsMaps(): Observable<any> {
    return this.httpClient.get<any>(urlEndPoints.reasonsMaps + 'getNightReasonsMaps');
  }
}
